<template>
  <transition name="fade" appear>
    <section
      class="summary"
      :class="
        props.rewards?.length > 0 || props.experiences?.length > 0
          ? 'alternate-layout'
          : ''
      "
    >
      <div>
        <p style="text-align:left; margin:0;"><img src="@/assets/logos/lions-loyal.png" alt="" width="75"></p>
        <h1>You have chosen the <span>{{ plan }} {{plan.includes('Plan') ? '' : 'Plan'}}</span></h1>
        <div class="price">
          <p>The price of this plan is <span>{{ props.planInfo.Price }}</span></p>
          <p class="payment-plan" v-if="plan !== 'Stadium Pass'">
            {{['Silver Mini-Plan', 'Blue Mini-Plan', 'Club Membership', 'Reserve Membership'].includes(plan) ? '*' : ''}}(On our monthly payment plan it is
            <span>{{ props.planInfo.PlanPrice }}</span> per month)
          </p>
        </div>
        <div class="games-holder">          
          <div class='games-holder-content'>
            <div>
              <p>
                {{ props.games?.length }}
                <span>{{ `Game${props.games?.length === 1 ? "" : "s"}` }}</span>
              </p>
              <Games :games="planInfo.Opponents && planInfo.Opponents.length > 0 ? planInfo.Opponents : props.games" needsBlue/>
            </div>
          </div>
          <div class="image">
            <img src="@/assets/images/field.jpg" alt="" />
          </div>
        </div>
        <SummaryBenefits recommended :benefits="planInfo.Benefits.filter((benefit) => { return benefit.Summary; })"/>      
        <p v-if="['Club Membership', 'Reserve Membership'].includes(plan)" class='disclaimer'>Disclaimer: Please note that some benefits may not be applicable based on the time of year in which your Lions Loyal Membership is purchased as some events may have passed.</p>         
        <p v-if="['Silver Mini-Plan', 'Blue Mini-Plan', 'Club Membership', 'Reserve Membership'].includes(plan)" class='disclaimer'>*{{$store.state.disclaimer[plan]}}</p>         
      </div>
      <div>
        <div
          class="rewards-and-experiences"
          v-if="props.rewards?.length > 0 || props.experiences?.length > 0"
        >
          <section>
            <h2 v-if="props.rewards?.length > 0">
              <span>Rewards</span>
            </h2>
            <div class="rewards" v-if="props.rewards?.length > 0">
              <ul>
                <li v-for="reward in props.rewards">
                  {{ reward.value.Title }}
                </li>
              </ul>
            </div>
          </section>
          <section>
            <h2 v-if="props.experiences?.length > 0">
              <span>Experiences</span>
            </h2>
            <div class="experiences" v-if="props.experiences?.length > 0">
              <ul>
                <li v-for="experience in props.experiences">
                  {{ experience.value.Title }}
                </li>
              </ul>
            </div>
          </section>
        </div>
        <AlternatePlan v-if="alternativePlan !== null" :downgrade="downgrade" :upgradeTitle="upgradeTitle" :upgradeLink="upgradeLink" :upgradeTitleWithCallToAction="upgradeTitleWithCallToAction" :benefits="benefits" :startingAt="alternativePlan.StartingAt"/>        
      </div>
    </section>    
  </transition>
  <section class='buy'>
      <a
        class="buy-now"
        target="_blank"
        :href="props.planInfo.BuyLink ? props.planInfo.BuyLink : '#'"
        >Submit And Select Seat Location
        <svg
          width="4"
          height="7"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="m.806 6.605-.714-.71 2.47-2.467L0 .881.714.17 4 3.427.806 6.605Z"
            fill="#fff"
          />
        </svg>
      </a>
    </section>
</template>
<script setup>
import Games from "@/components/Games";
import SummaryBenefits from "@/components/SummaryBenefits";
import AlternatePlan from "@/components/AlternatePlan";
import { useStore } from "vuex";
import { ref } from "vue";

const store = useStore();
const props = defineProps({
  plan: String,
  planInfo: Object,
  games: Array,
  rewards: Array,
  experiences: Array,
});
let upgradeLink = "";
let upgradeTitle = "";
let upgradeTitleWithCallToAction = "";
let alternativePlan = ref(props.planInfo.Upgrade);
let downgrade = false;
let benefits = ref([]);
if (props.planInfo.ManualUpgradeLink) {
  upgradeLink = props.planInfo.ManualUpgradeLink;
  upgradeTitle = ` ${props.planInfo.ManualUpgradeLink}`;
  upgradeTitleWithCallToAction = `View ${props.planInfo.ManualUpgradeLink}`;
} else if (props.planInfo.Upgrade?.Title) {
  upgradeLink = `${props.planInfo.Upgrade.Title} Summary`;
  upgradeTitle = `${props.planInfo.Upgrade.Title}`;
  upgradeTitleWithCallToAction = `Upgrade To ${props.planInfo.Upgrade.Title}`;
  benefits = props.planInfo.Upgrade.Benefits.filter((benefit) => {return benefit.Upgrade})
} else if(props.planInfo.Downgrade) {
  downgrade = true;
  upgradeLink = `${props.planInfo.Downgrade.Title} Summary`;
  upgradeTitle = `${props.planInfo.Downgrade.Title}`;
  upgradeTitleWithCallToAction = `Switch To ${props.planInfo.Downgrade.Title}`;
  alternativePlan = props.planInfo.Downgrade;
  benefits = props.planInfo.Benefits.filter((benefit) => {return benefit.Downgrade})
}
store.commit("setActivePlan", props.plan);
</script>
<style lang="scss" scoped>
.disclaimer {
  padding:10px 0;
  color:#fff;
}
#app section.buy {
  max-width: 1400px;
  margin: 0 auto;
  text-align: center;
  a {
    max-width: 335px;
    margin:0 auto;
  }
}
.games-holder {
  position: relative;
  display: flex;
  margin-bottom: 8px;
  border-top-left-radius: 20px;
  overflow: hidden;
  
  @media (min-width: 900px) {
    max-width: 650px;
  }
  p {
    font-size: 1.375rem;
    line-height: 1;
    text-align: center;
    text-transform: uppercase;
    font-family: "United Sans Cd Hv";
    font-weight: 900;
    color: #0076b6;
    span {
      display: block;
      font-size: 1.25rem;
    }
  }
  > div {
    position: relative;
    background: #0076b6;    
    > div {
      padding: 15px 35px;
      padding-right: 10px;
      box-sizing: border-box;
      flex-grow: 1;
      background: #dadada;
      background-size: cover;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      gap: 25px;
    }
  }
  .games-holder-content {
    width:70%;
    > div {
      height:100%;
    }
  }
  .image {
    pointer-events: none;
    position: relative;
    overflow: hidden;
    width: 30%;
    img {
      height: 100%;
      object-fit: cover;
    }
  }
}
.summary {
  display: flex;
  justify-content: center;
  align-items: stretch;
  max-width: 1400px;
  margin: 0 auto;
  gap: 70px;
  padding: 0 15px;
  flex-direction: column;
  
  @media (min-width: 900px) {
    flex-direction: row;
    align-items: stretch;
    
    > div {
      flex-grow: 1;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
  }
  }
}
h1 {
  font-family: "United Sans Cd Md";
  font-weight: 500;
  font-size: 2.5em;
  line-height: 1;
  text-transform: uppercase;
  color: #ffffff;
  text-shadow: 0px 3px 0px rgba(0, 0, 0, 0.15);
  span {
    font-family: "United Sans Cd Hv";
    font-weight: 900;
  }
}
h2 {
  font-family: "United Sans Cd Hv";
  font-weight: 900;
  font-size: 1.25rem;
  line-height: 1;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #ffffff;
  border-bottom: 1px solid #ffffff;
  padding-bottom: 9px;
  span {
    border-bottom: 4px solid #fff;
    padding-bottom: 6px;
  }
}
ul {
  margin-top: 18px;
  margin-bottom: 20px;
  column-count: 2;
  li {
    font-family: "United Sans Cd Md";
    font-weight: 500;
    font-size: 1.125rem;
    line-height: 1.22;
    color: #ffffff;
    list-style: disc outside;
    list-style-type: "✓";
    margin-left: 15px;
    padding-left: 11px;
    &::marker {
      color: #bbb;
    }
    &:not(:first-child) {
      margin-top: 8px;
    }
  }
}
.price {
  font-size: 1.5rem;
  line-height: 1.125;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: #ffffff;
  font-family: "United Sans Cd Bd";
  font-weight: bold;
  margin-top: 20px;
  margin-bottom: 25px;
  .payment-plan {
    font-family: "United Sans Cd Md";
    font-weight: 500;
  }
  span{
    display: inline-block;
  }
}
.buy-now {
  user-select: none;
  font-family: "United Sans Cd Hv";
  font-weight: 900;
  border-top-left-radius: 20px;
  border-bottom-right-radius: 20px;
  overflow: hidden;
  background-color: #fff;
  padding: 12px;
  font-size: 1.125rem;
  text-transform: uppercase;
  color: #0076b6;
  display: block;
  margin-top: 30px;
  text-align: center;
}
a {
  width: 100%;
  @media (min-width: 700px) {
    width: auto;
    &.buy-now {
      width: 70%;
    }
  }
}
</style>